import { DatePicker } from 'antd';
import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 600px;
  max-width: 95%;
  display:flex;
  position:relative;
  /* The folder dialog now stacks a picker, the security fields, the link
     it just made and every link already live. Without a ceiling that
     column runs past the bottom of a laptop screen and the buttons —
     including the one that copies the link — cannot be reached. */
  max-height: 90vh;
`;

export const ModalContent = styled.div`
width:100%;
  padding: 24px;
  /* Scrolls rather than clips once the column exceeds the ceiling above.
     min-height:0 because a flex child will not shrink below its content
     without it, which would push the overflow back outside the box. */
  overflow-y: auto;
  min-height: 0;
`;

export const Title = styled.h2`
  margin: 0 0 8px 0;
  font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 20px;
display:flex;
color:#1B2028;
`;
export const SpanTitle = styled.h2`
  margin: 0 0 8px 0;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 20px;
  leading-trim: Cap height;
  line-height: 30px;
  letter-spacing: 0%;
  color:#48566B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
`;

export const Subtitle = styled.p`
font-family: 'Manrope', sans-serif;
  font-size: 12px;
  color: #5A6C87;
  margin-bottom: 20px;
`;

export const FileName = styled.span`
  color: #3366cc;
  text-decoration: underline;
`;
export const SubLabel = styled.div`
font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 16px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
color:#1B2028;
margin-top:20px;
`
export const Label = styled.label`
  display: block;
  font-size: ${({ small }) => (small ? '13px' : '14px')};
  margin-top: ${({ small }) => (small ? '12px' : '20px')};
  margin-bottom: 6px;
  color: #5A6C87;
`;


export const StyledDatePicker = styled(DatePicker)`
  font-size: 13px;
  color: black;
  width: 100%;
  height: 40px;
  padding: 6px 10px;
  cursor: pointer;

 &.error {
    border: 1px solid #C63939 !important;
  }

  .ant-picker {
    border: 1px solid ${({ error }) => (error ? '#d32f2f' : '#DDE2E9')};
    border-radius: 6px;
    transition: all 0.2s;

    &:hover {
      border-color: ${({ error }) => (error ? '#d32f2f' : '#0C53BB')} !important;
    }

    &.ant-picker-focused {
      border-color: ${({ error }) => (error ? '#d32f2f' : '#0C53BB')} !important;
      box-shadow: 0 0 0 2px
        ${({ error }) =>
          error ? 'rgba(211, 47, 47, 0.2)' : 'rgba(12, 83, 187, 0.2)'};
    }
  }

  .ant-picker-input > input::placeholder {
    font-size: 13px;
    opacity: 1;
    color: #5A6C87;
  }
`;


export const GenerateButton = styled.button`
  background: none;
  border: none;
  color: #0C53BB;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'Manrope', sans-serif;
font-weight: 600;

leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;

`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 48px;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 7px 11px;
  background: #f2f2f2;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  height:32px;
`;

export const ShareButton = styled.button`
  padding: 7px 11px;
  height:32px;
  background: #0C53BB;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;



export const ModalWrapper = styled.div`
  background: white;
  padding: 24px;
  width: 600px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
`;
export const BackButton = styled.div`
display :flex;
position:absolute;
font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 0.813rem;
leading-trim: Cap height;
line-height: 28px;
letter-spacing: 0%;
vertical-align: middle;
padding:6px;
align-items:center;
color:#5A6C87;
cursor:pointer;
right:7px;
top:14px;
&:hover{
background:#F3F4F7;
}
`

export const CopyButton = styled.button`
  font-size: 13px;
  color: #3366cc;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
`;

export const Divider = styled.hr`
  margin: 24px 0;
  border: none;
  height: 1px;
  background-color: #eee;
`;

export const AccessRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
`;

export const FooterButton = styled.button`
  padding: 8px 16px;
  background: #f2f2f2;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  color: #333;

  &:hover {
    background: #e0e0e0;
  }
`;

export const PeopleList = styled.div`
  margin-top: 8px;
`;

export const Person = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
`;

export const PasswordWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  width: 100%;
`;


export const PasswordRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  input {
    flex: 1;
  }
`;
export const HorizondalLine = styled.hr`
  border: 1px solid #f3f4f7;
  margin-bottom: 24px;
  margin-top: 24px;
  position: absolute;
  left: 0;
  right: 0;
`;

export const ExpiryText = styled.p`
  font-size: 13px;
  color: #6b7280;
  margin-top: 12px;
`;

export const AccessListSection = styled.div`
  margin-top: 20px;
  display:flex;
  flex-direction:column;
  gap:24px;
`;

export const AccessUser = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color:#1B2028;
  margin-bottom:6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const RevokeLink = styled.button`
  background: none;
  border: none;
  color: #3366cc;
  font-size: 13px;
  font-weight: 500;
  margin-top: 20px;
  cursor: pointer;
  font-family: 'Manrope', sans-serif;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;


`;

export const PasswordInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 12px;
  border: 1px solid ${({ error }) => (error ? '#d32f2f' : '#ccc')};
  border-radius: 6px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${({ error }) => (error ? '#d32f2f' : '#0C53BB')} !important;
    box-shadow: 0 0 0 2px
      ${({ error }) =>
        error ? 'rgba(211, 47, 47, 0.2)' : 'rgba(12, 83, 187, 0.2)'};
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${({ error }) => (error ? '#d32f2f' : '#ccc')};
  border-radius: 6px;
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  &:focus {
    border-color: ${({ error }) => (error ? '#d32f2f' : '#0C53BB')} !important;
    box-shadow: 0 0 0 2px
      ${({ error }) =>
        error ? 'rgba(211, 47, 47, 0.2)' : 'rgba(12, 83, 187, 0.2)'};
  }
`;

export const EyeIconWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 12px;
  margin-top: 8px;
  margin-left: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ErrorIconWrapper = styled.span`
  display: flex;
  font-size: 14px;
  margin-top: 2px;
  align-items: center;
`;

export const DisabledPasswordInput = styled(PasswordInput)`
caret-color: transparent;
`
// --- Multi-folder picker and visible links (folder share only) ---------
// Matthew, 9/9: one link should be able to carry several folders, and the
// link itself has to be on screen — not only in an email.

export const FolderPicker = styled.div`
  max-height: 168px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 4px;
  margin-bottom: 4px;
`;

export const FolderRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  /* Indented by depth so the shape of the file is readable at a glance. */
  padding-left: ${({ depth }) => 8 + depth * 18}px;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  color: #1a1a1a;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #f5f7fa;
  }

  input {
    cursor: pointer;
    accent-color: #0c53bb;
  }
`;

export const PickerNote = styled.p`
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  color: #666;
  margin: 0 0 12px;
`;

export const LinkPanel = styled.div`
  border: 1px solid #b7d3f5;
  background: #f2f7fe;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
`;

export const LinkText = styled.div`
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  color: #0c53bb;
  word-break: break-all;
  margin-bottom: 8px;
`;

// The new link, as a field and a button: the field so it can be selected
// and copied by hand when the clipboard refuses, the button because that
// is the one thing the person wants to do next.
export const CopyRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const LinkInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #b7d3f5;
  border-radius: 4px;
  background: #fff;
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  color: #0c53bb;
`;

export const CopyLinkButton = styled(ShareButton)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #ececec;

  &:last-child {
    border-bottom: none;
  }
`;

export const LinkMeta = styled.div`
  font-family: "Manrope", sans-serif;
  font-size: 12px;
  color: #666;

  strong {
    display: block;
    font-size: 13px;
    color: #1a1a1a;
    font-weight: 600;
  }
`;

// Reveal and copy sit side by side inside the password field. Two
// separately-positioned icons would land on top of one another, since
// EyeIconWrapper pins itself to the right edge.
export const PasswordIcons = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;

  span,
  svg {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
`;
